import React from 'react'
import DeleteFeatureMutation from 'components/mutations/DeleteFeature'
import DangerDropdownMenuItem from 'components/DangerDropdownMenuItem'
import { Button, ModalV2, Dialog, Code } from 'stylist'

const DeleteFeatureModal = ({ feature, children }) => (
  <ModalV2
    render={({ hide }) => (
      <DeleteFeatureMutation feature={feature}>
        {({ deleteFeature }) => (
          <Dialog>
            <Dialog.Header>
              <Dialog.Title>Delete Feature</Dialog.Title>
            </Dialog.Header>
            <Dialog.Body>
              Are you sure you want to delete the feature
              <Code>{feature.name}</Code>? Doing so will disable the feature for
              all users.
              <strong>
                Only perform this action if this feature is no longer referenced
                in code.
              </strong>
            </Dialog.Body>
            <Dialog.Footer>
              <Dialog.CancelButton onClose={hide} />
              <Button kind="danger" onClick={deleteFeature}>
                Delete feature
              </Button>
            </Dialog.Footer>
          </Dialog>
        )}
      </DeleteFeatureMutation>
    )}
  >
    {({ show }) => (
      <DangerDropdownMenuItem to="#" onClick={show}>
        Delete feature
      </DangerDropdownMenuItem>
    )}
  </ModalV2>
)

export default DeleteFeatureModal



// WEBPACK FOOTER //
// ./src/routes/admin/features/components/DeleteFeatureModal.js